export const loginForm = {
    init: function () {
        document.body.addEventListener('click', this.showLoginForm);
    },

    showLoginForm: function (e) {
        const target = e.target;
        if (!target.matches('a.showlogin') && !target.closest('a.showlogin')) {
            return;
        }

        const loginForm = document.querySelector('form.login, form.woocommerce-form--login');
        loginForm && loginForm.classList.toggle('d-none');
        return false;
    },
};
